import { InjectionToken } from '@angular/core'

export let MOMENT_TOKEN = new InjectionToken<object>('moment')
